"use client";

import type { JSX } from "react";
import { motion, type Variants } from "framer-motion";
import { WA_NUMBERS } from "@/lib/consultation-links";
import { openWhatsAppWithUtm } from "@/lib/whatsapp";
import { consultationCtaClassName } from "@/lib/cta-styles";

const headingVariants: Variants = {
  hidden: { opacity: 0, filter: "blur(8px)" },
  visible: {
    opacity: 1,
    filter: "blur(0px)",
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};


const consultationActions = [ "Talk to a Specialist"];

export const CompanyFormationCallToActionSection = (): JSX.Element => {
  return (
    <section
      className="relative z-50 w-full bg-black"
      aria-labelledby="client-guidance-heading"
    >
      <div className="relative mx-auto min-h-[420px] w-full overflow-hidden sm:aspect-[1440/810]  2xl:aspect-[1440/617] sm:min-h-0 sm:max-h-[1017px]">
        <img
          className="absolute opacity-50 inset-0 h-full w-full object-cover"
          alt="Image"
          src="/home-v3/image-43.jpg"
        />
        <div className="relative flex w-full flex-col items-center gap-8 px-4 py-14 sm:absolute sm:left-1/2 sm:top-[15.9%] sm:w-[min(60.42%,956px)] sm:-translate-x-1/2 sm:px-0 sm:py-0">
          <header className="flex w-full flex-col gap-6 items-center justify-center">
            <motion.h2
              id="client-guidance-heading"
              className="[font-family:'Suisse_Works_Trial-Bold',Helvetica] text-center text-[clamp(24px,3.34vw,48px)] font-bold leading-[1.242] tracking-[0] text-white"
              variants={headingVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.6 }}
            >
              Ready to Get Your Hong Kong  <br />
            Accounts Prepared Properly?
            </motion.h2>
            <motion.p
              className="flex w-full flex-col justify-center max-w-[726px] [font-family:'Suisse_Intl_Trial-Regular',Helvetica] text-center text-lg font-normal leading-6 tracking-[0] text-[#fefefe]"
              variants={headingVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.6 }}
            >
        Get financial statements, management reporting and accounts that are actually ready for what comes next, prepared by a qualified team. <br/><br/>Tell us where your accounting currently stands and we will show you what needs to happen first.
            </motion.p>
          </header>
          <div className="flex flex-col items-center  gap-[21px]">
            <div className="flex flex-wrap items-start justify-center gap-4">
              {consultationActions.map((action) => {
                const className = consultationCtaClassName(action);

                return (
                  <button key={action} type="button" onClick={() => openWhatsAppWithUtm(WA_NUMBERS, "accounting-services")} className={`cursor-pointer ${className}`}>
                    {action}
                  </button>
                );
              })}
            </div>
            <div className="flex items-center justify-center gap-5">
              <img
                className="w-[120px] h-5"
                alt="Frame"
                src="/home-v3/frame-122-1.png"
              />
              <p className="[font-family:'Suisse_Intl_Trial-Regular',Helvetica] text-white whitespace-nowrap text-sm lg:text-[clamp(6px,1.25vw,18px)] font-normal leading-4 tracking-[0]">
                100+ Reviews
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
